import React from 'react';
import styled from 'styled-components';
import { mdBold, smRegular } from '../theme/typography';
import { themeColor } from '../theme/colors';
import Skeleton from '../Skeleton/Skeleton';

const Columns = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 57px;
`;

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;

  &:not(:last-child) {
    padding-bottom: 24px;
    border-bottom: 1px solid ${themeColor('strokeSecondary')};
  }
  &:not(:first-child) {
    padding-top: 24px;
  }
`;

const SectionTitle = styled.div`
  ${mdBold};
  color: ${themeColor('textPrimary')};
`;

const Column = styled.div`
  display: flex;
  width: 347px;
  flex-direction: column;
  align-items: flex-start;

  &:not(:has(${StyledSection})) {
    gap: 16px;
  }
`;

const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 30px;
`;

const Title = styled.div`
  ${smRegular};
  color: ${themeColor('textTertiary')};
  white-space: nowrap;
`;

const Value = styled.div`
  ${smRegular};
  color: ${themeColor('textPrimary')};
  max-width: 250px;
  overflow: hidden;
`;


const WrappableColumns = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 106px;

  & ${Column} {
    width: 100%;
    max-width: 347px;
  }

  & ${Value} {
    max-width: inherit;
  }

  /* Small window */
  @media (max-width: 1100px) {
    flex-direction: column;
    gap: 16px;

    & ${Column} {
      width: 100%;
      max-width: inherit;
    }
  }
`;


interface RowProps extends React.PropsWithChildren {
  title: string;
  loading?: boolean;
  className?: string;
}

function Row({ children, title, loading, className }: RowProps) {
  return (
    <StyledRow aria-label={title} className={className}>
      <Title className="title">
        {loading ? <Skeleton width={110} height={18} /> : title}
      </Title>
      <Value className="value">
        {loading ? <Skeleton height={18} width={220} /> : children}
      </Value>
    </StyledRow>
  );
}

function Section({ children, title }: RowProps) {
  return (
    <StyledSection aria-label={title}>
      <SectionTitle>{title}</SectionTitle>
      <Column>{children}</Column>
    </StyledSection>
  );
}

export default {
  WrappableColumns,
  Columns,
  Column,
  Row,
  Section,
};
